module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/poster-2-a3eb1a77d0db44245ec067393d7b6883.jpg";